import React, { useState, useEffect } from "react";
import { FaExternalLinkAlt } from "react-icons/fa";
import "./Projects.css";
import { getProjects } from "../../../firebase/projectServices";

const Projects = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchFeaturedProjects = async () => {
      try {
        const allProjects = await getProjects();
        // Filter to only show featured projects
        const featuredProjects = allProjects.filter(
          (project) => project.featured === true
        );
        setProjects(featuredProjects);
        setLoading(false);
      } catch (err) {
        console.error("Error fetching featured projects:", err);
        setError("Não foi possível carregar os projetos em destaque.");
        setLoading(false);
      }
    };

    fetchFeaturedProjects();
  }, []);

  if (loading) {
    return (
      <section className="projects-section" id="projects">
        <div className="projects-container">
          <h2 className="projects-title">Projetos em Destaque</h2>
          <div className="loading-indicator">
            <div className="loading-spinner"></div>
            <p>Carregando projetos...</p>
          </div>
        </div>
      </section>
    );
  }

  if (error) {
    return (
      <section className="projects-section" id="projects">
        <div className="projects-container">
          <h2 className="projects-title">Projetos em Destaque</h2>
          <p className="error-message">{error}</p>
        </div>
      </section>
    );
  }

  return (
    <section className="projects-section" id="projects">
      <div className="projects-container">
        <h2 className="projects-title">Projetos em Destaque</h2>
        <p className="projects-subtitle">
          Conheça alguns dos projetos que desenvolvemos para nossos clientes
        </p>

        {projects.length === 0 ? (
          <p className="no-projects-message">
            Nenhum projeto em destaque no momento.
          </p>
        ) : (
          <div className="projects-grid">
            {projects.map((project, index) => (
              <div
                className="project-card"
                key={project.id}
                style={{ animationDelay: `${index * 0.2}s` }}
              >
                <div className="project-image-container">
                  <img
                    src={project.image}
                    alt={project.title}
                    className="project-image"
                    onError={(e) => {
                      e.target.src = "/images/project-placeholder.jpg";
                    }}
                  />
                  <div className="project-overlay">
                    <a
                      href={project.demoLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="project-link"
                    >
                      <FaExternalLinkAlt />
                      <span>Acessar site</span>
                    </a>
                  </div>
                </div>
                <div className="project-info">
                  <span className="project-type">{project.type}</span>
                  <h3 className="project-title">{project.title}</h3>
                  <p className="project-description">
                    {typeof project.description === "string"
                      ? project.description
                      : project.description.substring(0, 120) + "..."}
                  </p>
                  <div className="project-tags">
                    {project.tags &&
                      project.tags.map((tag, tagIndex) => (
                        <span key={tagIndex} className="project-tag">
                          {tag}
                        </span>
                      ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        <div className="projects-cta">
          <a href="/projetos" className="portfolio-button">
            Ver Portfólio Completo
            <FaExternalLinkAlt className="button-icon" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default Projects;
